/**
 * Quick Menu favorites — user shortcuts, not full app navigation.
 * Future: replace DEFAULT_QUICK_MENU_FAVORITE_IDS with user.quickMenuFavorites.
 */

import { isEmployee } from "./permissions";

export const QUICK_MENU_FAVORITE_IDS = Object.freeze({
  PAYROLL: "payroll",
  ESTIMATES: "estimates",
  TIME_TRACKING: "time_tracking",
  TIME_LOGS: "time_logs",
  CREATE_PROJECT: "create_project",
});

/** Manager / Admin layout (unchanged). */
export const DEFAULT_QUICK_MENU_FAVORITE_IDS = [
  QUICK_MENU_FAVORITE_IDS.PAYROLL,
  QUICK_MENU_FAVORITE_IDS.ESTIMATES,
  QUICK_MENU_FAVORITE_IDS.TIME_TRACKING,
  QUICK_MENU_FAVORITE_IDS.CREATE_PROJECT,
];

/**
 * Employee layout — Start Session, Payroll, and Time Logs.
 * Time Logs occupies the otherwise unused Estimates radial slot.
 */
export const EMPLOYEE_QUICK_MENU_FAVORITE_IDS = [
  QUICK_MENU_FAVORITE_IDS.TIME_TRACKING,
  QUICK_MENU_FAVORITE_IDS.PAYROLL,
  QUICK_MENU_FAVORITE_IDS.TIME_LOGS,
];

const QUICK_MENU_FAVORITE_CATALOG = {
  [QUICK_MENU_FAVORITE_IDS.PAYROLL]: {
    id: QUICK_MENU_FAVORITE_IDS.PAYROLL,
    visibilityKey: "payroll",
    alt: "Payroll",
    animate: { x: -50, y: -125 },
    transition: { duration: 0.25 },
    iconOpacity: 0.7,
  },
  [QUICK_MENU_FAVORITE_IDS.ESTIMATES]: {
    id: QUICK_MENU_FAVORITE_IDS.ESTIMATES,
    visibilityKey: "estimates",
    alt: "Estimates",
    guideClassName: "guide-estimates-hub",
    iconClassName: "quick-menu-estimates-icon",
    animate: { x: -150, y: 20 },
    transition: { duration: 0.25 },
  },
  [QUICK_MENU_FAVORITE_IDS.TIME_TRACKING]: {
    id: QUICK_MENU_FAVORITE_IDS.TIME_TRACKING,
    visibilityKey: null,
    alt: "Start Session",
    guideClassName: "guide-command-center",
    animate: { x: 30, y: -150 },
    transition: { duration: 0.25, delay: 0.05 },
    iconOpacity: 0.7,
  },
  [QUICK_MENU_FAVORITE_IDS.TIME_LOGS]: {
    id: QUICK_MENU_FAVORITE_IDS.TIME_LOGS,
    visibilityKey: "timeLogs",
    alt: "Time Logs",
    guideClassName: "guide-time-logs",
    // Estimates slot — unused for employees; keeps the circular layout full.
    animate: { x: -150, y: 20 },
    transition: { duration: 0.25, delay: 0.06 },
    iconOpacity: 0.7,
  },
  [QUICK_MENU_FAVORITE_IDS.CREATE_PROJECT]: {
    id: QUICK_MENU_FAVORITE_IDS.CREATE_PROJECT,
    visibilityKey: "createProject",
    alt: "Projects",
    guideClassName: "guide-create-project",
    animate: { x: -115, y: -65 },
    transition: { duration: 0.25, delay: 0.08 },
    iconOpacity: 0.7,
  },
};

/**
 * @param {object | null | undefined} actor
 * @returns {string[]}
 */
export function getQuickMenuFavoriteIdsForActor(actor) {
  if (isEmployee(actor)) {
    return [...EMPLOYEE_QUICK_MENU_FAVORITE_IDS];
  }

  return [...DEFAULT_QUICK_MENU_FAVORITE_IDS];
}

/**
 * @param {string[] | null | undefined} favoriteIds — future user.quickMenuFavorites
 * @param {Record<string, boolean>} visibility — capability-driven show/hide flags
 */
export function resolveQuickMenuFavorites(
  favoriteIds = DEFAULT_QUICK_MENU_FAVORITE_IDS,
  visibility = {},
) {
  const ids = Array.isArray(favoriteIds) ? favoriteIds : DEFAULT_QUICK_MENU_FAVORITE_IDS;

  return ids
    .map((id) => QUICK_MENU_FAVORITE_CATALOG[id])
    .filter(Boolean)
    .filter((item) => {
      if (!item.visibilityKey) {
        return true;
      }
      return visibility[item.visibilityKey] !== false;
    });
}
